import React, { useEffect, useState } from "react";
import Table from "../../../Utils/Table/Table1";
import { getFundstatus } from "../../../Services/Admin/Addmin";
import { UpdatestatusForpaymenthistory, InrUpdatestatusForpaymenthistory } from "../../../Services/Admin/Addmin";
import Swal from "sweetalert2";
import { fDateTime } from "../../../Utils/Date_format/datefromat";
import Modal from "react-modal"; // Import Modal if not already imported
import { GetAdminUsername } from "../../../Services/Superadmin/Superadmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import { useLocation } from "react-router-dom";

const Withdraw = () => {
  const state = useLocation()

  const TokenData = getUserFromToken();
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState("Pending");
  const [selectedValues, setSelectedValues] = useState({});
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedBankDetails, setSelectedBankDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeMarket, setActiveMarket] = useState(state?.state?.item === "rupee" ? "INR" : "USD");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const handleOpenModal = (data) => {
    setSelectedBankDetails(data);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedBankDetails(null);
  };

  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [uploadedImage, setUploadedImage] = useState(null);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [selectedAdminName, setSelectedAdminName] = useState("");
  const [adminNames, setAdminNames] = useState([]);

  useEffect(() => {
    getAdminNames();
    getAllfundsstatus();
  }, [search, activeTab, selectedAdminName, activeMarket, page, rowsPerPage]);

  const getAdminNames = async () => {
    try {
      const response = await GetAdminUsername();

      setAdminNames(response.data);
    } catch (error) {
    }
  };





  const handleSelectChange = async (rowId, row, event) => {
    const newSelectedValues = {
      ...selectedValues,
      [rowId]: event.target.value,
    };
    setSelectedValues(newSelectedValues);

    if (event.target.value === "1") {
      setCurrentRowId(row._id);
      setShowCompleteModal(true);
    } else {
      await Updatestatus(row._id, newSelectedValues[rowId], row);
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setUploadedImage(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleComplete = async () => {
    if (!transactionId || !uploadedImage) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please provide both Transaction ID and Screenshot.",
        timer: 2000,
      });
      return;
    }

    const status = "1"; // Complete
    const data = {
      admin_id: selectedAdminName,
      id: currentRowId,
      status,
      transactionId,
      screenshot: uploadedImage,
    };

    try {
      let response;
      if (activeMarket === "INR") {
        response = await InrUpdatestatusForpaymenthistory(data);
      } else {
        response = await UpdatestatusForpaymenthistory(data);
      }

      if (response.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.message || "Request marked as complete.",
          timer: 2000,
        });
        setShowCompleteModal(false);
        setTransactionId("");
        setUploadedImage(null);
        getAllfundsstatus();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.message || "Failed to update the request.",
          timer: 2000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "An unexpected error occurred.",
        timer: 2000,
      });
    }
  };

  const handleCancel = () => {
    setShowCompleteModal(false);
    setTransactionId("");
    setUploadedImage(null);
  };

  const columns = [
    { Header: "Name", accessor: "FullName" },

    {
      Header: "Request",
      accessor: "type",
      Cell: ({ row }) => {
        const item = row;  // ✔️ Correct data
        return item?.type == 0 ? "Withdrawal" : "Deposit";
      },

    },


    { Header: "Balance", accessor: "Balance" },

    {
      Header: "User Balance",
      accessor: "UserBalance",
      Cell: ({ row }) => row.UserBalance?.toFixed(4),
    },

    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ row }) => {
        return fDateTime(row.createdAt);
      },
    },


    {
      Header: "Bank Details",
      accessor: "bankDetails",
      Cell: ({ row }) => (
        <button
          onClick={() => handleOpenModal(row)}

          className="btn btn-primary btn-sm d-flex align-items-center"
        >
          <i className="bi bi-eye me-2"></i> View Bank Details
        </button>
      ),
    },
  ];

  if (activeTab === "Pending") {
    columns.push({
      Header: "Action",
      accessor: "Action",
      Cell: ({ row }) => (
        <select
          className="form-select"
          onChange={(event) =>
            handleSelectChange(row._id, row, event)
          }
          value={selectedValues[row._id] || "0"}
        >
          <option value="0">Pending</option>
          <option value="2">Reject</option>
          <option value="1">Complete</option>
        </select>
      )


    });
  }

  const Updatestatus = async (id, status, row) => {
    try {
      const admin_id = selectedAdminName;
      const data = { admin_id, id, status, type: "DEBIT", Balance: row.Balance };
      const response = await UpdatestatusForpaymenthistory(data);

      if (response.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            response.message ||
            "An unexpected error occurred. Please try again.",
          timer: 2000,
        });
        getAllfundsstatus();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            response.message ||
            "Failed to update the request. Please try again.",
          timer: 2000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.message || "An unexpected error occurred. Please try again.",
        timer: 2000,
      });
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const getAllfundsstatus = async () => {
    try {
      if (selectedAdminName === "") {
        setData([]);
        return;
      }

      const reqData = {
        adminid: selectedAdminName,
        type: 0,
        activeTab,
        market: activeMarket,
        search,
        page,
        limit: rowsPerPage
      };

      const response = await getFundstatus(reqData);

      if (response.status) {
        setData(response.data);  // backend filtered data
        setTotalPages(response.pagination?.totalPages || 1);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const filterDataByStatus = (status) => {
    return data.filter((item) => item.status === status);
  };

  const renderTable = (status) => {
    return (
      <div className="table-responsive">
        {/* Controls Row */}
        <div className="row g-3 align-items-end mb-4  ms-4 py-1">
          {/* Search Input */}
          <div className="col-md-6 col-lg-4">
            <label htmlFor="searchInput" className="form-label fw-semibold">
              🔍 Search:
            </label>
            <input
              id="searchInput"
              className="form-control"
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}

            />
          </div>

          {/* Admin Dropdown */}
          <div className="col-md-6 col-lg-4">
            <label htmlFor="userSelect" className="form-label fw-semibold mb-2">
              Admin Name:
            </label>
            <select
              id="userSelect"
              className="form-select"
              value={selectedAdminName}
              onChange={(e) => setSelectedAdminName(e.target.value)}
            >
              <option value="">Select Admin</option>
              {adminNames?.map((item, index) =>
                item ? (
                  <option value={item._id} key={index}>
                    {item.UserName}
                  </option>
                ) : null
              )}
            </select>
          </div>
        </div>

        <h5 className="mb-3 ms-4 fw-semibold">{activeTab} Transactions</h5>

        <Table
          columns={columns}
          data={data}
          page={page}
          totalPages={totalPages}
          initialRowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />

      </div>
    );
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);         // Table1 prev/next se ye call karega
  };

  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
  };


  return (
    <div>
      <div className="row">
        <div className="demo-view">
          <div className="container-fluid mt-5" >
            <div className="row" >
              <div className="col-xl-12" >
                <div className="card dz-card" id="nav-pills" style={{ background: "#F7F7F7" }}>
                  <div className="card-header flex-wrap border-0">
                    <h2 className="card-title py-2">🏦 Withdrawal History</h2>
                    <div className="wallet-tabs">
                      <div className="btn-group gap-1" role="group">

                        {TokenData?.market.includes(0) && <button
                          type="button"
                          className={`btn ${activeMarket === "USD" ? "btn-primary" : "btn-outline-primary"}`}
                          onClick={() => setActiveMarket("USD")}
                        >
                          <i className="fas fa-dollar-sign me-2"></i>
                          USD Wallet
                        </button>}

                        {TokenData?.market.includes(1) && <button
                          type="button"
                          className={`btn ${activeMarket === "INR" ? "btn-primary" : "btn-outline-primary"}`}
                          onClick={() => setActiveMarket("INR")}
                        >
                          <i className="fas fa-rupee-sign me-2"></i>
                          INR Wallet
                        </button>}

                      </div>
                    </div>
                  </div>
                  <div className="tab-content mt-4" id="myTabContent3">
                    <div
                      className="tab-pane fade show active"
                      id="NavPills"
                      role="tabpanel"
                      aria-labelledby="home-tab3"
                    >
                      <div className="card-body pt-0">
                        {/* <ul className="nav nav-pills nav-pills1 mb-4 light">
                          <li className="nav-item">
                            <a
                              href="#navpills-1"
                              className={`nav-link navlink ${activeTab === "Pending" ? "active" : ""
                                }`}
                              data-bs-toggle="tab"
                              aria-expanded="false"
                              onClick={() => handleTabClick("Pending")}
                            >
                              Pending
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              href="#navpills-2"
                              className={`nav-link navlink ${activeTab === "Complete" ? "active" : ""
                                }`}
                              data-bs-toggle="tab"
                              aria-expanded="false"
                              onClick={() => handleTabClick("Complete")}
                            >
                              Complete
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              href="#navpills-3"
                              className={`nav-link navlink ${activeTab === "Reject" ? "active" : ""
                                }`}
                              data-bs-toggle="tab"
                              aria-expanded="true"
                              onClick={() => handleTabClick("Reject")}
                            >
                              Reject
                            </a>
                          </li>
                        </ul> */}
                        <ul className="seg-tabs w-full">
                          <li
                            className={`seg-item ${activeTab === "Pending" ? "active" : ""}`}
                            onClick={() => handleTabClick("Pending")}
                          >
                            Pending
                          </li>

                          <li
                            className={`seg-item ${activeTab === "Complete" ? "active" : ""}`}
                            onClick={() => handleTabClick("Complete")}
                          >
                            Complete
                          </li>

                          <li
                            className={`seg-item ${activeTab === "Reject" ? "active" : ""}`}
                            onClick={() => handleTabClick("Reject")}
                          >
                            Reject
                          </li>
                        </ul>

                        <div className="tab-content">
                          <div
                            id="navpills-1"
                            className={`tab-pane ${activeTab === "Pending" ? "active" : ""
                              }`}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="card transaction-table">
                                  <div className="card-body p-0">
                                    <div
                                      className="tab-content"
                                      id="myTabContent1"
                                    >
                                      <div
                                        className="tab-pane fade show active"
                                        id="Week"
                                        role="tabpanel"
                                        aria-labelledby="Week-tab"
                                      >
                                        {renderTable(0)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="navpills-2"
                            className={`tab-pane ${activeTab === "Complete" ? "active" : ""
                              }`}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="card transaction-table">
                                  <div className="card-body p-0">
                                    <div
                                      className="tab-content"
                                      id="myTabContent1"
                                    >
                                      <div
                                        className="tab-pane fade show active"
                                        id="Week"
                                        role="tabpanel"
                                        aria-labelledby="Week-tab"
                                      >
                                        {renderTable(1)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="navpills-3"
                            className={`tab-pane ${activeTab === "Reject" ? "active" : ""
                              }`}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="card transaction-table">
                                  <div className="card-body p-0">
                                    <div
                                      className="tab-content"
                                      id="myTabContent1"
                                    >
                                      <div
                                        className="tab-pane fade show active"
                                        id="Week"
                                        role="tabpanel"
                                        aria-labelledby="Week-tab"
                                      >
                                        {renderTable(2)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={showModal}
        onRequestClose={handleCloseModal}
        contentLabel="Bank Details"
        style={{
          content: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "480px",
            height: "400px",
            padding: "30px",
            borderRadius: "16px",
            background: "#ffffff",
            borderLeft: "5px solid #0d6efd",   // 💙 Blue strip
            boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
            zIndex: 3000
          },

          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.55)",
            backdropFilter: "blur(4px)",
            WebkitBackdropFilter: "blur(4px)",
            zIndex: 2000,
          },

        }}
      >
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4
            className="fw-bold mb-0"
            style={{ color: "#0d6efd" }}
          >
            Bank Details
          </h4>

          <button
            onClick={handleCloseModal}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "20px",
              fontWeight: "bold",
              color: "#333",
              cursor: "pointer",
              lineHeight: "1",
            }}
          >
            ✕
          </button>
        </div>


        {selectedBankDetails ? (
          <div className="text-start">
            <div className="mb-3">
              <label className="form-label fw-semibold">Account Holder Name</label>
              <div className="form-control bg-light">{selectedBankDetails.accountHolderName || "N/A"}</div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Bank Account No</label>
              <div className="form-control bg-light">{selectedBankDetails.bankAccountNo || "N/A"}</div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Bank IFSC</label>
              <div className="form-control bg-light">{selectedBankDetails.bankIfsc || "N/A"}</div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Bank Name</label>
              <div className="form-control bg-light">{selectedBankDetails.bankName || "N/A"}</div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">UPI ID</label>
              <div className="form-control bg-light">{selectedBankDetails.upiId || "N/A"}</div>
            </div>
          </div>
        ) : (
          <p className="text-center">No bank details available.</p>
        )}

        <div className="text-center mt-4">
          <button onClick={handleCloseModal} className="btn btn-outline-danger px-4 py-2">
            Close
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={showCompleteModal}
        onRequestClose={handleCancel}
        contentLabel="Complete Transaction"
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "500px",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            zIndex: 3000,
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 2000,
          },
        }}
      >
        <h4 className="text-center mb-4">Complete Transaction</h4>
        <div>
          <div className="mb-3">
            <label htmlFor="transactionId" className="form-label">
              Transaction ID
            </label>
            <input
              type="text"
              id="transactionId"
              className="form-control"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="screenshot" className="form-label">
              Upload Screenshot
            </label>
            <input
              type="file"
              id="screenshot"
              className="form-control"
              accept="image/*"
              onChange={handleImageUpload}
            />
          </div>
        </div>
        <div className="text-center mt-4">
          <button onClick={handleComplete} className="btn btn-success me-3">
            Mark Complete
          </button>
          <button onClick={handleCancel} className="btn btn-danger">
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Withdraw;
